import type { Meta, StoryObj } from '@storybook/react';

import { HamadoriHeadline } from './HamadoriHeadline';

export default {
  title: 'area/HamadoriHeadline',
  component: HamadoriHeadline,
} as Meta;

export const Basic: StoryObj<typeof HamadoriHeadline> = {
  args: {
    children: '浜通りエリア',
  },
};
